import { useEffect, useState } from "react";

import { FileDropdown } from "components";
import { NoteEditBtn, NoteTypeIconLabel } from "components/Notes";
import { UserInfo } from "components/Notes/NoteRow/components";
import "components/Notes/NoteRow/NoteRow.scss";

import type { AppointmentNote, CarNote } from "models";

type NoteRowProps = {
  carNote?: CarNote;
  isCarNote?: boolean;
  appointmentNote?: AppointmentNote;
  onSelectNote?: () => void;
};

export const NoteRow = ({ appointmentNote, carNote, onSelectNote, isCarNote = false }: NoteRowProps) => {
  const [isTextExpanded, setIsTextExpanded] = useState(false);

  const noteType = appointmentNote?.appointment_note_type_id ?? carNote?.car_note_type_id ?? null;
  if (!noteType) return null;

  const attachments = appointmentNote ? appointmentNote.attachments : carNote?.attachments;
  const note = appointmentNote ? appointmentNote.note : carNote?.note || "";

  const user = appointmentNote ? appointmentNote.created_by : carNote?.created_by;
  const userId = appointmentNote ? appointmentNote.created_by_id : carNote?.updated_by_id || carNote?.created_by_id || 0;
  const updatedBy = appointmentNote ? appointmentNote.updated_by : carNote?.updated_by;

  const updatedOn = appointmentNote ? appointmentNote.updated_on : carNote?.updated_on;
  const createdOn = appointmentNote ? appointmentNote.created_on : carNote?.created_on;
  const phoneNr = appointmentNote ? appointmentNote.phone_nr : "";
  const appointmentName = appointmentNote?.name || "";
  const email = appointmentNote?.email || "";

  const doesContainHtml = (text: string) => /<[^>]*>/g.test(text);

  useEffect(() => {
    if (note) setIsTextExpanded(false);
  }, [note]);

  return (
    <div className="AppointmentNoteRow">
      <div className="note-details-info-container">
        <div className="icon-btn-container">
          <NoteTypeIconLabel type={appointmentNote?.appointment_note_type_id} isCarNote={isCarNote} />
          <NoteEditBtn type={noteType} isCarNote={isCarNote} onSelectNote={onSelectNote} />
        </div>
        {phoneNr && <div className="appointment-note-label">{phoneNr}</div>}
        {appointmentName && <div className="appointment-note-label">{appointmentName}</div>}
        {email && <div className="appointment-note-label">{email}</div>}
        {attachments && attachments.length > 0 && (
          <div>
            <FileDropdown files={attachments} fromAPI={Boolean(appointmentNote?.public_account_id)} />
          </div>
        )}
        {doesContainHtml(note) ? (
          <div
            dangerouslySetInnerHTML={{ __html: note }}
            className={`appointment-note-text ${!isTextExpanded ? "ellipsis" : ""}`}
            onClick={() => setIsTextExpanded(prev => !prev)}
          />
        ) : (
          <div className={`appointment-note-text ${!isTextExpanded ? "ellipsis" : ""}`} onClick={() => setIsTextExpanded(prev => !prev)}>
            {note}
          </div>
        )}

        <UserInfo appointmentNote={appointmentNote} updatedBy={updatedBy} user={user} userId={userId} updatedOn={updatedOn} createdOn={createdOn} />
      </div>
    </div>
  );
};
